import { auth } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';

export const validateFirebaseSetup = async () => {
  try {
    // Test auth initialization
    return new Promise<boolean>((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        console.log('✅ Firebase Authentication is properly configured', user ? 'User is signed in' : 'No user signed in');
        resolve(true);
      }, (error) => {
        console.error('❌ Firebase Authentication error:', error);
        resolve(false);
      });
    });
  } catch (error) {
    console.error('❌ Firebase Authentication error:', error);
    return false;
  }
};

export const getAuthDomain = () => {
  const hostname = window.location.hostname;
  return hostname;
};